import MetaLandingPage from './MetaLandingPage';

export default MetaLandingPage;
